export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SET_USER_PREFERENCE = 'SET_USER_PREFERENCE';
